import $ from 'jquery';

import config from './config.json';
import settings from './settings.json';

// Currently config has no attributes, but in the future it may have
export default $.extend(true,config,settings);